import styled from 'styled-components';

// COMPONENTS
import Banner from '@/components/Banners/Banner';

export const BannerWatchNextStyled = styled(Banner)`
  img {
    width: 263px;
    height: 203px;
    z-index: 2;
  }
`;

export default BannerWatchNextStyled;
